export default function CTASection() {
  return (
    <section className="flex flex-col lg:flex-row min-h-[500px] md:min-h-[600px]">
      {/* Left side - Image with text overlay */}
      <div className="w-full lg:w-1/2 relative bg-background-100 flex items-center justify-center overflow-hidden min-h-[350px] lg:min-h-0">
        <img
          src="https://readdy.ai/api/search-image?query=Fashionable%20person%20walking%20through%20sunlit%20urban%20street%20carrying%20shopping%20bags%2C%20modern%20city%20architecture%20background%2C%20golden%20hour%20lighting%2C%20cinematic%20lifestyle%20photography%2C%20warm%20vibrant%20colors%2C%20aspirational%20editorial%20style&width=1000&height=800&seq=cta-lifestyle-v3&orientation=landscape"
          alt="Kakobuy Shopping Lifestyle"
          className="absolute inset-0 w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-black/25 via-transparent to-transparent"></div>
        <div className="relative z-10 w-full px-8 md:px-12 py-12 self-end">
          <p className="text-xs font-semibold text-background-50/80 uppercase tracking-widest mb-3">
            Ready to Shop?
          </p>
          <p className="font-heading text-3xl md:text-5xl font-extrabold text-background-50 leading-[1.1]">
            Stop
          </p>
          <p className="font-heading text-4xl md:text-6xl font-extrabold text-background-50 leading-[1.1]">
            Searching.
          </p>
          <p className="font-heading text-5xl md:text-7xl font-extrabold text-primary-300 leading-[1.1]">
            Start Finding.
          </p>
        </div>
      </div>

      {/* Right side - CTA */}
      <div className="w-full lg:w-1/2 bg-background-50 flex items-center justify-center px-8 md:px-16 py-16 md:py-0">
        <div className="max-w-md text-center lg:text-left">
          <h2 className="font-heading text-3xl md:text-4xl font-extrabold text-foreground-950 leading-[1.15] mb-6">
            Get The Full<br />Spreadsheet
          </h2>
          <p className="text-sm md:text-base text-foreground-600 leading-relaxed mb-8">
            Unlike manual searching across dozens of pages, our organized kakobuy spreadsheet database gives you instant access to thousands of curated finds. Compare prices, browse by category, and discover trending products — all updated daily for the best shopping experience.
          </p>
          <a
            href="https://kaspreadsheet.com"
            target="_blank"
            rel="noopener nofollow"
            className="inline-flex items-center gap-2 bg-foreground-950 text-background-50 px-8 py-3.5 rounded-full text-sm font-semibold hover:bg-foreground-800 transition-colors whitespace-nowrap cursor-pointer"
          >
            Explore Full Spreadsheet
            <div className="w-4 h-4 flex items-center justify-center">
              <i className="ri-arrow-right-up-line text-base"></i>
            </div>
          </a>
        </div>
      </div>
    </section>
  );
}